import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';
import { site, nav } from '../mock/mock';

export default function Footer() {
  return (
    <footer className="bg-sage-900 text-cream/80">
      <div className="max-w-[1240px] mx-auto px-5 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="inline-block bg-white rounded-2xl px-6 py-4 mb-6 shadow-lg">
              <img src="/photos/logo.webp" alt="KD Veterinary Physiotherapy" className="h-20 w-auto" />
            </div>
            <p className="text-sm leading-relaxed text-white max-w-xs">
              Fully qualified and insured, NAVP-registered veterinary physiotherapy for equines, canines and other
              family pets across {site.area}.
            </p>
            <div className="flex gap-3 mt-6">
              <a
                href={site.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full bg-sage-700 flex items-center justify-center text-white hover:bg-sage-500 transition-all"
              >
                <Instagram size={18} />
              </a>
              <a
                href={site.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full bg-sage-700 flex items-center justify-center text-white hover:bg-sage-500 transition-all"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-serif text-lg mb-5">Explore</h4>
            <ul className="space-y-3 text-sm">
              {nav.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="text-cream/70 hover:text-sage-300 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/canine-hydrotherapy" className="text-cream/70 hover:text-sage-300 transition-colors">
                  Rehabilitation / Class 4 Laser
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-serif text-lg mb-5">Get in touch</h4>
            <ul className="space-y-4 text-sm">
              <li>
                <a href={site.phoneHref} className="flex items-center gap-3 text-cream/70 hover:text-sage-300 transition-colors">
                  <Phone size={17} className="text-sage-400" /> {site.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${site.email}`} className="flex items-center gap-3 text-cream/70 hover:text-sage-300 transition-colors break-all">
                  <Mail size={17} className="text-sage-400 shrink-0" /> {site.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-cream/70">
                <MapPin size={17} className="text-sage-400 shrink-0 mt-0.5" /> {site.area}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-sage-800 mt-12 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-cream/50">
          <p>© {new Date().getFullYear()} KD Veterinary Physiotherapy. All rights reserved.</p>
          <p>West Midlands · Warwickshire · Surrounding Areas</p>
        </div>
      </div>
    </footer>
  );
}
